import React from "react";

const languages = [
  { id: "01", name: "Amharic" },
  { id: "02", name: "French" },
  { id: "03", name: "Haitian Creole" },
  { id: "04", name: "Hausa" },
  { id: "05", name: "Igbo" },
  { id: "06", name: "Kinyarwanda" },
  { id: "07", name: "Lingala" },
  { id: "08", name: "Nigerian Pidgin" },
  { id: "09", name: "Portuguese" },
  { id: "10", name: "Shona" },
  { id: "11", name: "Somali" },
  { id: "12", name: "Swahili" },
  { id: "13", name: "Twi" },
  { id: "14", name: "Wolof" },
  { id: "15", name: "Yoruba" },
  { id: "16", name: "Zulu" },
  { id: "17", name: "Ewe" },
];

const LanguageItem = ({ id, name }) => (
  <div className="group flex flex-col pb-2.5 sm:pb-3 border-b border-[#4d8a79] hover:border-white/60 transition-colors duration-200 w-full cursor-default">
    <div className="flex items-center gap-3">
      <span className="text-[#F5C955] text-sm sm:text-base font-bold select-none">
        {id}
      </span>
      <span className="text-white text-base sm:text-lg lg:text-[19px] font-bold font-['Axiforma',sans-serif] tracking-wide group-hover:text-emerald-100 transition-colors">
        {name}
      </span>
    </div>
  </div>
);

const SupportedLanguages = () => {
  return (
    <section className="w-full bg-[#1E6C56] py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 text-white">
      <div className="w-full max-w-7xl mx-auto flex flex-col items-center">
        {/* Header: Eyebrow, Title, and Description */}
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-aos="fade-up">
          <span className="text-[#F5C955] text-sm sm:text-base font-black tracking-[0.2em] uppercase mb-3 font-['Axiforma',sans-serif]">
            OUR COVERAGE
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-[46px] font-extrabold text-white tracking-tight leading-[1.2] font-['Axiforma',sans-serif]">
            Languages We Support
          </h2>
          <p className="mt-4 text-emerald-50/85 text-sm sm:text-base leading-relaxed max-w-2xl mx-auto font-normal">
            Our language professionals work across a growing range of African, Caribbean and global languages.
          </p>
        </div>

        {/* Languages Grid */}
        <div
          className="w-full mt-12 sm:mt-14 lg:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 sm:gap-x-12 lg:gap-x-14 gap-y-8 sm:gap-y-10"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {/* Items 01 - 16 */}
          {languages.slice(0, 16).map((lang) => (
            <LanguageItem key={lang.id} id={lang.id} name={lang.name} />
          ))}

          {/* Item 17 (Ewe) - Centered on desktop & tablet */}
          <div className="col-span-1 sm:col-span-2 lg:col-span-4 flex justify-center">
            <div className="w-full sm:max-w-[260px] lg:max-w-[250px]">
              <LanguageItem id={languages[16].id} name={languages[16].name} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportedLanguages;
